module.exports = __webpack_public_path__ + "static/hybrid-work-models-could-help-businesses-save-500b-a-year-54fd87887d113436a1a86da55effc08e.png";